import { ICompany } from 'app/shared/model/company.model';
import { IMaintenanceReview } from 'app/shared/model/maintenance-review.model';

export interface IPart {
  id?: number;
  name?: string | null;
  code?: string | null;
  cycleKm?: number | null;
  cycleDate?: number | null;
  cycleHour?: number | null;
  imageContentType?: string | null;
  image?: string | null;
  objectKey?: string | null;
  description?: string | null;
  company?: ICompany | null;
  maintenanceReviews?: IMaintenanceReview[] | null;
}

export const defaultValue: Readonly<IPart> = {};
